import { Link } from 'react-router-dom'
import { Article } from '../../../types'
import { formatDate, getImageUrl, truncate } from '../../../utils/helpers'

interface ArticleCardProps {
  article: Article
}

function ArticleCard({ article }: ArticleCardProps) {
  const coverImage = article.cover_media?.file_path
    ? getImageUrl(article.cover_media.file_path)
    : ''

  const authorName = article.author
    ? `${article.author.first_name} ${article.author.last_name}`
    : null

  return (
    <article className="article-card">
      <Link to={`/actualites/${article.slug}`} className="article-card-link">
        <div className="article-card-image">
          {coverImage ? (
            <img src={coverImage} alt={article.title} />
          ) : (
            <div className="article-card-placeholder">Pas d'image</div>
          )}
        </div>
        <div className="article-card-content">
          <h3 className="article-card-title">{article.title}</h3>
          <p className="article-card-excerpt">
            {truncate(article.excerpt, 150)}
          </p>
          <div className="article-card-meta">
            <span className="article-date">{formatDate(article.published_at)}</span>
            {authorName && (
              <>
                <span className="separator">•</span>
                <span className="article-author">{authorName}</span>
              </>
            )}
          </div>
        </div>
      </Link>
    </article>
  )
}

export default ArticleCard
